/**
 * 役職と在籍状態の札（docs/06 4-9・総点検 M9）。
 *
 * 役職は色を付けない札（会社の色が赤系でも警告に見えないように）、在籍状態は「利用中（緑）」「ログイン前」「無効（灰）」の札で出す。
 * **色だけで意味を伝えない**よう、札の中には必ず言葉を書く（docs/06 1-3）。
 */
import type { ReactNode } from 'react';
import { memberStatusLabel } from '../members/labels.js';

export function RoleTag({ label }: { label: string }): ReactNode {
  if (label.trim() === '') return null;
  return <span className="admin-tag admin-tag-role">{label}</span>;
}

export function MemberStatusTag({ status }: { status: string }): ReactNode {
  const tone = status === 'active' ? 'ok' : status === 'deactivated' ? 'muted' : 'neutral';
  return <span className={`admin-tag admin-tag-${tone}`}>{memberStatusLabel(status)}</span>;
}
